<template>
  <div class="product-card mb-lg">
    <h2 class="product-subheading">
      How to get the best rate
    </h2>
    <ul class="product-list">
      <li v-for="(tip, index) in tips" :key="index" class="staggered-list-item">
        <span class="product-list-item">
          <b class="text-dark font-bold">{{ getTipTitle(tip) }}:</b> 
          <span class="text-dark font-normal">{{ getTipDescription(tip) }}</span>
        </span>
      </li>
    </ul>
  </div>
  <hr class="w-full mt-6 h-[3px] bg-gray-300" />
</template>

<script>
export default {
  name: 'ProductPageHowTo',
  props: {
    tips: {
      type: Array,
      required: true
    }
  },
  methods: {
    getTipTitle(tip) {
      // If the tip contains a colon, extract the title (before the colon)
      if (tip.includes(':')) {
        return tip.split(':')[0].trim();
      }
      // Otherwise, return empty string
      return '';
    },
    getTipDescription(tip) {
      // If the tip contains a colon, extract the description (after the colon)
      if (tip.includes(':')) {
        return tip.split(':').slice(1).join(':').trim();
      }
      // Otherwise, return the whole tip
      return tip;
    }
  }
};
</script>

<style scoped>
.product-list-item {
  line-height: 1.6;
  margin-bottom: 1rem;
  display: block;
}
</style> 